import { ApplicationUserStore } from './application-user.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';

@Injectable({ providedIn: 'root' })
export class ApplicationUserQuery extends BaseQuery {
  constructor(store: ApplicationUserStore) {
        super(store);
    }
}
